<template>
  <div>
    <label>{{'Attached Photos'|translate}}</label>
    <div class="row">
      <div class="col-md-12">
        <div class="pull-right">
          <input type="file" id="file-upload" ref="file" v-on:change="handleFileUpload()" style="display:none"/>
          <a class="btn btn-primary" :disabled="uploadingPhoto" v-on:click="triggerFile">
            <i v-if="!uploadingPhoto" class="fa fa-plus"></i>
            <i v-if="uploadingPhoto" class="fas fa-spinner fa-spin"></i>
            {{'Upload photo'|translate}}
          </a>
        </div>
      </div>
      <div class="col-md-12 flowhidden clear">
        <p v-if="editPhotos.length === 0">{{'There is no attach photo'|translate}}</p>
        <div class="gallery" v-if="editPhotos !== null">
          <div  v-for="(photo) in editPhotos"  :key="photo.id" class="gallery-item" >
            <img :src="photo.url_thumb" class="thumb"  />
            <a  v-on:click="removePhoto(photo)" class="btn btn-danger"><i class="fas fa-times"></i> {{'Remove'|translate}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Utils from '@/helpers/utils'

export default {
  name: 'managejobphotos',
  components: {
  },
  props: ['history'],
  data () {
    return this.initData()
  },
  created () {
    if (this.history && this.history.image_set_data) {
      // clone from original params
      this.editPhotos = JSON.parse(JSON.stringify(this.history.image_set_data))
    } else {
      this.editPhotos = []
    }
  },
  mounted () {
    
  },
  methods: {
    loadData(){
      if (this.history.images){
        this.editPhotos = JSON.parse(JSON.stringify(this.history.images))
      }else{
        this.editPhotos = []
      }
    },
    initData () {
      return {
        uploadingPhoto: false,
        editPhotos: null
      }
    },
    ok () {
      this.$refs.theModal.close()
      this.$emit('refreshHistory')
    },
    getListIds () {
      let result = []
      if (this.editPhotos) {
        result = this.editPhotos.map((item) => { return item.id })
      }
      return result
    },
    triggerFile () {
      this.$refs.file.click()
    },
    handleFileUpload () {
      let file = this.$refs.file.files[0]

      if (file.size >= 524288) {
        return this.$alertify.alertWithTitle(this.$t('Confirm'), this.$t('Exceed maximum upload file size is 500kb'))
      }

      var validExtensions = ['jpg', 'png', 'jpeg']
      var reader = new FileReader()
      let _this = this
      reader.onloadend = function (e) {
        _this.selectedFile = true
        let arr = (new Uint8Array(e.target.result)).subarray(0, 4)
        let header = ''
        for (let i = 0; i < arr.length; i++) {
          header += arr[i].toString(16)
        }

        let mimeType = Utils.mimeType(header)
        if (mimeType === 'unknown') {
          return _this.$alertify.alertWithTitle(_this.$t('Confirm'), _this.$t('Only these file types are accepted') + ' : ' + validExtensions.join(', '))
        }
        const blob = new Blob([e.target.result], {type: 'image/png'})
        _this.uploadPhoto(blob)
      }
      reader.readAsArrayBuffer(file)
    },
    uploadPhoto (blob) {
      this.uploadingPhoto = true
      let formData = new FormData()
      formData.append('file', blob, 'file.jpg')
      if (this.history.id) {
        formData.append('history_id', this.history.id)
      }
      let headers = Utils.getHeader(this,true)
      console.log('headers',headers)
      headers['Content-Type'] = 'multipart/form-data'

      Utils.request(this,true,'land').post('/historyImage/', formData, {headers: headers}).then((response) => {
        this.editPhotos.push(response.data.data)
        this.uploadingPhoto = false
        this.$emit('refreshPhotoList', this.editPhotos)
        // if (this.job) {
        //   this.updateJob()
        // }
      }).catch(() => {
        this.uploadingPhoto = false
        this.$alertify.alertWithTitle(this.$t('Confirm'), this.$t('There was an issue when request, Please try again'))
      })
    },
    removePhoto (photo) {
      this.$alertify.confirmWithTitle(this.$t('Confirm'), this.$t('Are you sure to remove this photo ?'), () => {

        Utils.request(this,true,'land').delete(`/historyImage/${photo.id}` ).then((response) => {
          this.removeFromList(photo)
          // if (this.job) {
          //   this.updateJob()
          // }
        }).catch(() => {
          this.$alertify.alertWithTitle(this.$t('Confirm'), this.$t('There was an issue when request, Please try again'))
        })
        
      })
    },
    updateJob () {
      let clone = JSON.parse(JSON.stringify(this.job))
      delete clone.id
      let imageSet = this.editPhotos.map(item => { return item.id })
      clone.image_set = imageSet
      Utils.request(this).put(`/job/${this.job.id}/?expired=1`, clone).then(response => {})
    },
    removeFromList (photo) {
      for (let i = 0; i < this.editPhotos.length; i++) {
        if (this.editPhotos[i].id === photo.id) {
          this.editPhotos.splice(i, 1)
          if (this.history && this.history .id) {
            this.$emit('refreshPhotoList', this.editPhotos)
          }
          break
        }
      }
    },
    fillData (photos) {
      this.editPhotos = JSON.parse(JSON.stringify(photos))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Cultivation/ManageHistoryPhoto.vue